/**
 * Counts variants that count toward combinations / UI totals for one component:
 * non-empty (after trim) values not listed in `deactivatedValues`.
 */
export const countActiveVariantsForComponent = (
  componentValues: string[],
  deactivatedValues?: string[]
): number => {
  const deactivated = new Set(deactivatedValues ?? []);
  let count = 0;
  for (const value of componentValues) {
    if (!value || value.trim() === "") {
      continue;
    }
    if (deactivated.has(value)) {
      continue;
    }
    count++;
  }
  return count;
};
